import {
  Box,
  Typography,
  Button,
  Stack,
  AvatarGroup,
  Avatar,
  IconButton,
} from "@mui/material";
import { GitHub, LinkedIn, Twitter, Email } from "@mui/icons-material";
import QuickLinksFloating from "./QuickLinksFloating";

export default function MobileHeroFooter() {
  return (
    <Box
      sx={{
        width: "100%",              // Fill the parent container
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between", // Pushes followers to left, buttons to center, socials to right
        alignItems: "center",       // Vertically center everything
        px: { xs: 2, md: 6, lg: 10 }, // Horizontal padding
        py: 2,
        zIndex: 10,
        background: "rgba(15, 23, 42, 0.6)",
        backdropFilter: "blur(12px)",
        borderTop: "1px solid rgba(59, 130, 246, 0.2)", // Border only on top looks cleaner for footers
      }}
    >
      <Stack>
       <QuickLinksFloating/>
      </Stack>
      

      {/* 1. FOLLOWERS (Left side) */}
      <Stack spacing={0.5} alignItems="center">
        <AvatarGroup
          max={4}
          sx={{
            "& .MuiAvatar-root": {
              width: 26,
              height: 26,
              fontSize: "0.7rem",
            },
          }}
        >
          <Avatar src="/fan1.jpg" />
          <Avatar src="/fan2.jpg" />
          <Avatar src="/fan3.jpg" />
          <Avatar>+1k</Avatar>
        </AvatarGroup>

        <Typography
          variant="caption"
          sx={{ color: "#94a3b8", fontSize: 10, letterSpacing: 1 }}
        >
          FOLLOWERS
        </Typography>
      </Stack>

      {/* 2. NAVIGATION BUTTONS (Center - Desktop Only) */}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          display: { xs: "none", md: "none", lg: "flex" }, 
          alignItems: "center",
        }}
      >
        <Button
          variant="outlined"
          href="#projects"
          sx={{
            px: 3,
            py: 1,
            borderRadius: "12px",
            color: "#fff",
            borderColor: "rgba(59, 130, 246, 0.5)",
            fontSize: "13px",
          }}
        >
          See Projects
        </Button>
        
        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "12px",
            px: 3,
            py: 1,
            bgcolor: "#3b82f6",
            fontSize: "13px",
            "&:hover": { bgcolor: "#2563eb" },
          }}
        >
          Collaborate
        </Button>

        <Button
          variant="outlined"
          href="/resume.pdf"
          sx={{
            px: 3,
            py: 1,
            borderRadius: "12px",
            color: "#fff",
            borderColor: "rgba(59, 130, 246, 0.5)",
            fontSize: "13px",
          }}
        >
          View Resume
        </Button>
      </Stack>

      {/* 3. COLLABORATE BUTTON (Mobile/Tablet Only) */}
      <Button
        variant="contained"
        size="small"
        sx={{
          display: { xs: "flex", lg: "none" }, // Hidden on desktop
          textTransform: "none",
          fontWeight: 600,
          borderRadius: "12px",
          px: 2,
          py: 1,
          bgcolor: "#3b82f6",
          "&:hover": { bgcolor: "#2563eb" },
        }}
      >
        Collaborate
      </Button>
      

      {/* 4. SOCIALS (Right side) */}
      <Stack direction="row" spacing={{ xs: 0.5, md: 1 }}>
        <IconButton href="#" size="small" sx={{ color: "rgba(255,255,255,0.6)" }}>
          <GitHub fontSize="small" />
        </IconButton>
        <IconButton href="#" size="small" sx={{ color: "rgba(255,255,255,0.6)" }}>
          <LinkedIn fontSize="small" />
        </IconButton>
        <IconButton href="#" size="small" sx={{ color: "rgba(255,255,255,0.6)" }}>
          <Twitter fontSize="small" />
        </IconButton>
        <IconButton href="mailto:hi@example.com" size="small" sx={{ color: "rgba(255,255,255,0.6)" }}>
          <Email fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
}
